var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "gfu-project-card-reprint" }, [
    _c("div", [_vm._v("raised")]),
    _vm._v(" "),
    _c("div", { staticClass: "gfu-bt gfu-bt--b2" }, [
      _vm._v(_vm._s(_vm.formatedValue) + " more"),
    ]),
    _vm._v(" "),
    _c("div", [_vm._v("than the original")]),
    _vm._v(" "),
    _c("div", [_vm._v("campaign")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }